var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.request)?_c('div',[_c('div',{staticClass:"stepFormInn"},[_c('health-insurance-form',{attrs:{"request":_vm.request}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }